export const HOTEL_DETAILS_PANEL_SEOURL = '/hotelDetails';
export const ROUTING_CONFIG = 'routingConfig';
export const SPA_APP_NAME = 'chat-spa';
export const EXPERIENCE_SEGMENT = ['NOT Logged In'];
export const GAURDRAIL_ERROR_MESSAGE = `I can't help with that request, but I can help you find a great hotel. Tell me about your travel plans.`;
export const PII_DETECTED_ERROR_MESSAGE = `I can't use personal details. Can you ask again without that info?`;
export const GUARDRAIL_LIMIT_EXCEEDED_MESSAGE = `This chat has been disabled. Begin a new chat to proceed with finding a hotel.`;
export const CHAT_DISABLED_PLACEHOLDER = 'Start a new chat to continue';
